import { ApiService } from '@/api';
import {
  OneOfLatestAccomplishments,
  OneOfGeekHistoryElements,
} from '@/models/geek-profile';

export const HISTORY_ELEMENTS_LIMIT = 25;

export class HistoryApi {
  private readonly geeksBaseUrl = '/api/geeks';

  public async fetchLatestAccomplishment(geekId: string = 'self'): Promise<OneOfLatestAccomplishments> {
    const response = await ApiService.get(`${this.geeksBaseUrl}/${geekId}/latest-accomplishment`);

    return response.json();
  }

  public async fetchGeekHistory(
    geekId: string,
    seasonId: string,
    showOnlyBaseHistory: boolean,
    offset: number = 0,
    limit: number = HISTORY_ELEMENTS_LIMIT,
  ): Promise<{ data: OneOfGeekHistoryElements[], totalCount: number }> {
    const response = await ApiService.get(
      `${this.geeksBaseUrl}/${geekId}/history`,
      {
        params: {
          offset,
          limit,
          seasonId,
          showOnlyBaseHistory,
        },
      },
    );

    const data: OneOfGeekHistoryElements[] = await response.json();
    const totalCount: number = parseInt(response.headers.get('x-items-count') as string, 10);

    return new Promise((resolve) => resolve({ data, totalCount }));
  }
}
